import * as React from 'react';
import { Case } from './case';
import styles from './case-receipt.scss';
import { ButtonSecondary, CasePasswordBanner } from 'ui';
import { STATE } from 'app/constants';
import { containerFactory } from 'app/infrastructure/redux';
import { caseTranslations } from 'app/area/case/constants';
import { toCaseEdit } from 'app/area/shared/route-urls';
import { toAbsoluteUrl } from 'app/infrastructure/hosting';
import { authProvider } from 'dependencies/auth';
import { CaseState } from 'app/area/case/types-store';
import { globalVar } from 'app/infrastructure/universal';
import { escapeUrl } from 'app/components/favourite-layout/favourite/common/utils';
import { AppSetting } from 'app/infrastructure/hosting/app-settings';

interface CaseReceiptComponentProps {
  params: any;
  canRender: boolean;
  translation: any;
  children?: React.ReactNode;
}

class CaseReceiptComponent extends React.Component<CaseReceiptComponentProps> {
  public static statePath: string = STATE.case;

  public render() {
    const { params, canRender, translation } = this.props;
    const id = params.id;
    const anonCtx = globalVar('sessionStorage').getItem('anonCtx');

    const url = toAbsoluteUrl(toCaseEdit(id, ''), true) +
      (anonCtx ? `?anonCtx=${anonCtx}` : '');

    const handlePrint = (e: React.MouseEvent) => {
      e.preventDefault();
      window.print();
    };

    const hideAnonymousCasePassword = AppSetting.HideAnonymousCasePassword;

    return (
      <>
        {canRender && <div className={`container ${styles.receipt}`}>
          {!hideAnonymousCasePassword && <CasePasswordBanner textTitle={translation.public_case_submitted}>
            <p>{translation.public_follow_up}</p>
            <p><a href={escapeUrl(url)}>{url}</a></p>
            <p>{translation.public_info_case_password}</p>
            <p className={styles.casePassword}>{authProvider.getAuthorization()}</p>
            <div className={styles.print}>
              <p>{translation.public_print_info}</p>
              <ButtonSecondary onClick={handlePrint}>
                {translation.public_print}
              </ButtonSecondary>
            </div>
          </CasePasswordBanner>}
        </div>}
        <Case {...this.props} />
      </>
    );
  }
}

const selectors = {
  canRender: (state: CaseState) => state.schema && !state.fetching
};

export const CaseReceipt = containerFactory(
  CaseReceiptComponent,
  undefined,
  selectors,
  caseTranslations
);
